import React from 'react';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="w-full max-w-4xl mx-auto flex flex-col items-center px-2">
      {children}
    </div>
  );
};

export default Layout;